@import 'vars';
@import 'mixins';

.directory {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;

  &--softphone {
    gap: 10px;
  }

  &__banner {
    overflow: visible;
  }

  &__search {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;

    input {
      font-size: $font-size-small;
    }

    .searchbar-wrapper {
      width: 100%;
    }
  }
}
